var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "sidebar",
      staticStyle: { overflow: "hidden" },
      attrs: { id: "sidebar-block" },
    },
    [
      _c("div", { staticClass: "go-sidebar" }, [
        _c("div", { staticClass: "go-sidebar-header" }, [
          _c("div", { staticClass: "go-sidebar-title" }, [
            _vm._v(_vm._s(_vm.$t("briefing.briefingAgents"))),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "go-sidebar-body" },
          [
            _c(
              "vue-custom-scrollbar",
              {
                staticClass:
                  "go-list-inner overflow-y-scroll customScroll csScrollPosition ps listWrapBoxMyBriefing",
                attrs: { settings: _vm.scrollSettings },
              },
              [
                _c(
                  "div",
                  { staticClass: "go-sidebar-inner containerSideBar" },
                  [
                    _c("div", { staticClass: "go-panel myBriefingBox" }, [
                      _c(
                        "a",
                        {
                          staticClass: "go-panel-header",
                          attrs: {
                            "data-toggle": "collapse",
                            "data-target": "#go-topic-group1",
                            "aria-expanded": !_vm.isAgentsCollapsed,
                          },
                          on: { click: _vm.toggleAgents },
                        },
                        [
                          _c("div", { staticClass: "go-panel-title" }, [
                            _vm._v(
                              "\n                " +
                                _vm._s(_vm.$t("briefing.myAgents")) +
                                "\n                "
                            ),
                            _c("small", { staticClass: "go-count" }, [
                              _vm._v(
                                "(" +
                                  _vm._s(_vm.totalBriefingPagesPinned || 0) +
                                  ")"
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", [
                            _c("i", {
                              staticClass: "go-icon-20 go-icon-chevron-down",
                            }),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "go-panel-body collapse show p-0",
                          attrs: { id: "go-topic-group1" },
                        },
                        [
                          _c("div", { staticClass: "go-list-wrap" }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "go-list-inner overflow-y-scroll customScroll csScrollPosition ps listWrapBoxMyBriefing",
                              },
                              [
                                _c(
                                  "ul",
                                  {
                                    staticClass:
                                      "go-card-sub-list go-card-topic",
                                    staticStyle: { overflow: "hidden" },
                                  },
                                  [
                                    _c(
                                      "router-link",
                                      { attrs: { to: "/my-briefing" } },
                                      [
                                        _c(
                                          "li",
                                          {
                                            staticClass:
                                              "go-list-item go-list-all",
                                            on: {
                                              click:
                                                _vm.setSelectedAllBriefingPage,
                                            },
                                          },
                                          [
                                            _c(
                                              "a",
                                              {
                                                class: [
                                                  "go-card-link go-card-sub",
                                                  {
                                                    active:
                                                      this.$route.name ===
                                                      "MyBriefing-All",
                                                  },
                                                ],
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "go-card-img",
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "go-icon-24 go-icon-layout-grid-fill",
                                                    }),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "go-card-body",
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "go-card-title",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "briefing.allMyAgents"
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "go-card-info",
                                                      },
                                                      [
                                                        _c("span", {
                                                          staticClass:
                                                            "go-datetime",
                                                        }),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _vm.dailyThumbnail
                                      ? _c(
                                          "li",
                                          {
                                            staticClass:
                                              "go-list-item go-list-daily",
                                          },
                                          [
                                            _c(
                                              "router-link",
                                              {
                                                attrs: {
                                                  to: "/my-briefing/my-recap",
                                                },
                                              },
                                              [
                                                _c(
                                                  "a",
                                                  {
                                                    class: [
                                                      "go-card-link go-card-sub",
                                                      {
                                                        active:
                                                          this.$route.name ===
                                                          "MyRecap",
                                                      },
                                                    ],
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "go-card-img",
                                                      },
                                                      [
                                                        _c("img", {
                                                          attrs: {
                                                            src:
                                                              _vm.dailyThumbnail
                                                                .listDocumentFeatured &&
                                                              _vm.dailyThumbnail
                                                                .listDocumentFeatured
                                                                .length > 0
                                                                ? _vm
                                                                    .dailyThumbnail
                                                                    .listDocumentFeatured[0]
                                                                    .image_url
                                                                : "",
                                                          },
                                                          on: {
                                                            error:
                                                              _vm.onImageError,
                                                          },
                                                        }),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "go-card-body",
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "go-card-title",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "briefing.dailyGoover"
                                                                )
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "go-card-info",
                                                          },
                                                          [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "go-datetime",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.convertDate(
                                                                      _vm.moment(
                                                                        _vm
                                                                          .dailyThumbnail
                                                                          .createdDate
                                                                      )
                                                                    )
                                                                  )
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.weeklyThumbnail
                                      ? _c(
                                          "li",
                                          {
                                            staticClass:
                                              "go-list-item go-list-weekly",
                                          },
                                          [
                                            _c(
                                              "router-link",
                                              {
                                                attrs: {
                                                  to: "/my-briefing/my-recap",
                                                },
                                              },
                                              [
                                                _c(
                                                  "a",
                                                  {
                                                    class: [
                                                      "go-card-link go-card-sub",
                                                      {
                                                        active:
                                                          this.$route.name ===
                                                          "MyRecap",
                                                      },
                                                    ],
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "go-card-img",
                                                      },
                                                      [
                                                        _c("img", {
                                                          attrs: {
                                                            src: _vm.onImageError,
                                                          },
                                                          on: {
                                                            error:
                                                              _vm.onImageError,
                                                          },
                                                        }),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "go-card-body",
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "go-card-title",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "briefing.weeklyGoover"
                                                                )
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "go-card-info",
                                                          },
                                                          [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "go-datetime",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.formatDateAgo(
                                                                      _vm.moment(
                                                                        _vm
                                                                          .weeklyThumbnail
                                                                          .createdDate
                                                                      )
                                                                    )
                                                                  )
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm._l(
                                      _vm.uniqueBriefingAgentsPinned,
                                      function (item, index) {
                                        return _c(
                                          "li",
                                          {
                                            key: index + item.bpId,
                                            ref: "items",
                                            refInFor: true,
                                            class: [
                                              "go-list-item",
                                              {
                                                hide:
                                                  index >=
                                                  _vm.indexShowMyBriefingPage,
                                              },
                                            ],
                                            attrs: {
                                              id: "element_" + item.bpId,
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.setSelectedBriefingPage(
                                                  item
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "router-link",
                                              {
                                                attrs: {
                                                  to:
                                                    "/my-briefing/" + item.bpId,
                                                },
                                              },
                                              [
                                                _c(
                                                  "a",
                                                  {
                                                    class: [
                                                      "go-card-link go-card-sub",
                                                      {
                                                        active:
                                                          _vm.$route.params
                                                            .bpId == item.bpId,
                                                      },
                                                    ],
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "go-card-img",
                                                      },
                                                      [
                                                        _c("img", {
                                                          attrs: {
                                                            src:
                                                              item.newUrl ||
                                                              _vm.getImageSrc(
                                                                item.imageUri,
                                                                index
                                                              ),
                                                          },
                                                          on: {
                                                            error:
                                                              _vm.onImageError,
                                                          },
                                                        }),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "go-card-body",
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "go-card-title",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                item.briefingPageName
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "go-card-info",
                                                          },
                                                          [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "go-datetime",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.formatDateAgo(
                                                                      _vm.moment(
                                                                        item.modifyDate
                                                                      )
                                                                    )
                                                                  )
                                                                ),
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "button",
                                                              {
                                                                class: [
                                                                  "btn go-btn-icon",
                                                                  {
                                                                    active:
                                                                      !!item.isPinned ||
                                                                      false,
                                                                  },
                                                                ],
                                                                attrs: {
                                                                  type: "button",
                                                                  "data-toggle":
                                                                    "button",
                                                                  "aria-pressed":
                                                                    item.isPinned
                                                                      ? "true"
                                                                      : "false",
                                                                  disabled:
                                                                    _vm.getIsPinned,
                                                                },
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      $event.stopPropagation()
                                                                      $event.preventDefault()
                                                                      return _vm.handlePinBriefing(
                                                                        item.bpId,
                                                                        !item.isPinned
                                                                      )
                                                                    },
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    directives:
                                                                      [
                                                                        {
                                                                          name: "b-tooltip",
                                                                          rawName:
                                                                            "v-b-tooltip.hover",
                                                                          value:
                                                                            {
                                                                              customClass:
                                                                                "go-tooltip",
                                                                            },
                                                                          expression:
                                                                            "{ customClass: 'go-tooltip' }",
                                                                          modifiers:
                                                                            {
                                                                              hover: true,
                                                                            },
                                                                        },
                                                                      ],
                                                                    staticClass:
                                                                      "go-tooltip-area go-toggle-off",
                                                                    attrs: {
                                                                      title:
                                                                        _vm.$t(
                                                                          "briefing.label.pin.fav-on"
                                                                        ),
                                                                    },
                                                                  },
                                                                  [
                                                                    _c("i", {
                                                                      staticClass:
                                                                        "go-icon-18 go-icon-star",
                                                                    }),
                                                                  ]
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    directives:
                                                                      [
                                                                        {
                                                                          name: "b-tooltip",
                                                                          rawName:
                                                                            "v-b-tooltip.hover",
                                                                          value:
                                                                            {
                                                                              customClass:
                                                                                "go-tooltip",
                                                                            },
                                                                          expression:
                                                                            "{ customClass: 'go-tooltip' }",
                                                                          modifiers:
                                                                            {
                                                                              hover: true,
                                                                            },
                                                                        },
                                                                      ],
                                                                    staticClass:
                                                                      "go-tooltip-area go-toggle-on",
                                                                    attrs: {
                                                                      title:
                                                                        _vm.$t(
                                                                          "briefing.label.pin.fav-off"
                                                                        ),
                                                                    },
                                                                  },
                                                                  [
                                                                    _c("i", {
                                                                      staticClass:
                                                                        "go-icon-18 go-icon-star-on",
                                                                    }),
                                                                  ]
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        )
                                      }
                                    ),
                                  ],
                                  2
                                ),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _vm.getBriefingAgentsPinned.length > 3
                            ? _c("div", { staticClass: "go-panel-footer" }, [
                                _vm.loadMorePinnedPage ||
                                _vm.indexShowMyBriefingPage <
                                  _vm.getBriefingAgentsPinned.length
                                  ? _c(
                                      "button",
                                      {
                                        staticClass: "btn go-btn-more",
                                        attrs: {
                                          type: "button",
                                          disabled: _vm.loadingPinnedPage,
                                        },
                                        on: {
                                          click: function ($event) {
                                            $event.stopPropagation()
                                            $event.preventDefault()
                                            return _vm.viewMoreMyBriefingPage()
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              _vm.$t(
                                                "briefing.my-briefing.side-bar.view-more"
                                              )
                                            )
                                        ),
                                        _c("i", {
                                          staticClass:
                                            "go-icon-20 go-icon-chevron-down",
                                        }),
                                      ]
                                    )
                                  : _c(
                                      "button",
                                      {
                                        staticClass: "btn go-btn-more",
                                        attrs: { type: "button" },
                                        on: {
                                          click: _vm.viewLessBriefingPages,
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              _vm.$t(
                                                "briefing.my-briefing.side-bar.view-less"
                                              )
                                            )
                                        ),
                                        _c("i", {
                                          staticClass:
                                            "go-icon-20 go-icon-chevron-up",
                                        }),
                                      ]
                                    ),
                              ])
                            : _vm._e(),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "go-panel socialBriefingBox" }, [
                      _c(
                        "a",
                        {
                          staticClass: "go-panel-header",
                          attrs: {
                            "data-toggle": "collapse",
                            "data-target": "#go-topic-group2",
                            "aria-expanded": !_vm.isSocialCollapsed,
                          },
                          on: { click: _vm.toggleSocials },
                        },
                        [
                          _c("div", { staticClass: "go-panel-title" }, [
                            _vm._v(
                              "\n                " +
                                _vm._s(_vm.$t("briefing.socialAgents")) +
                                "\n                "
                            ),
                            _c("small", { staticClass: "go-count" }, [
                              _vm._v(
                                "(" +
                                  _vm._s(_vm.getTotalSubscribeBriefing || 0) +
                                  ")"
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", [
                            _c("i", {
                              staticClass: "go-icon-20 go-icon-chevron-down",
                            }),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "go-panel-body collapse show p-0",
                          attrs: { id: "go-topic-group2" },
                        },
                        [
                          _c("div", { staticClass: "go-list-wrap" }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "go-list-inner overflow-y-scroll customScroll csScrollPosition ps listWrapBoxMyBriefing",
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      overflow: "hidden",
                                      width: "auto",
                                      height: "auto",
                                    },
                                  },
                                  [
                                    _c(
                                      "ul",
                                      {
                                        staticClass:
                                          "go-card-sub-list go-card-topic",
                                      },
                                      [
                                        _c(
                                          "router-link",
                                          {
                                            attrs: {
                                              to: "/my-briefing/social",
                                            },
                                          },
                                          [
                                            _c(
                                              "li",
                                              {
                                                staticClass:
                                                  "go-list-item go-list-all",
                                                on: {
                                                  click:
                                                    _vm.setSelectedAllSocialPage,
                                                },
                                              },
                                              [
                                                _c(
                                                  "a",
                                                  {
                                                    class: [
                                                      "go-card-link go-card-sub",
                                                      {
                                                        active:
                                                          this.$route.name ===
                                                          "SocialBriefing-All",
                                                      },
                                                    ],
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "go-card-img",
                                                      },
                                                      [
                                                        _c("i", {
                                                          staticClass:
                                                            "go-icon-24 go-icon-layout-grid-fill",
                                                        }),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "go-card-body",
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "go-card-title",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "briefing.allSocialAgents"
                                                                )
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "go-card-info",
                                                          },
                                                          [
                                                            _c("span", {
                                                              staticClass:
                                                                "go-datetime",
                                                            }),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _vm._l(
                                          _vm.uniqueSocialBriefingPages,
                                          function (item, index) {
                                            return _c(
                                              "router-link",
                                              {
                                                key: item.bpId,
                                                class: [
                                                  "go-list-item",
                                                  {
                                                    hide:
                                                      index >=
                                                        _vm.indexShowSocial &&
                                                      !_vm.isFullSocialPages,
                                                  },
                                                ],
                                                attrs: {
                                                  to:
                                                    "/my-briefing/social/" +
                                                    item.bpId,
                                                },
                                              },
                                              [
                                                _c(
                                                  "li",
                                                  {
                                                    staticClass: "go-list-item",
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.setSelectedSocialPage(
                                                          item
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "a",
                                                      {
                                                        class: [
                                                          "go-card-link go-card-sub",
                                                          {
                                                            active:
                                                              _vm.$route.params
                                                                .bpId ==
                                                              item.bpId,
                                                          },
                                                        ],
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "go-card-img",
                                                          },
                                                          [
                                                            _c("img", {
                                                              attrs: {
                                                                src: item.imageUri,
                                                              },
                                                              on: {
                                                                error:
                                                                  _vm.onImageError,
                                                              },
                                                            }),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "go-card-body",
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "go-card-title",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    item.briefingPageName
                                                                  )
                                                                ),
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "go-card-info",
                                                              },
                                                              [
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "go-datetime",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm.formatDateAgo(
                                                                          _vm.moment(
                                                                            item.modifyDate
                                                                          )
                                                                        )
                                                                      )
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            )
                                          }
                                        ),
                                      ],
                                      2
                                    ),
                                  ]
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _vm.getTotalSubscribeBriefing > 5
                              ? _c("div", { staticClass: "go-panel-footer" }, [
                                  !_vm.isFullSocialPages &&
                                  _vm.indexShowSocial <
                                    _vm.getTotalSubscribeBriefing
                                    ? _c(
                                        "button",
                                        {
                                          staticClass: "btn go-btn-more",
                                          attrs: {
                                            type: "button",
                                            disabled:
                                              _vm.socialBriefingPages.length <
                                              _vm.getTotalSubscribeBriefing
                                                ? !_vm.getCheckCallApiSubBP
                                                : false,
                                          },
                                          on: {
                                            click:
                                              _vm.loadMoreBriefingSocialPages,
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(
                                                _vm.$t(
                                                  "briefing.my-briefing.side-bar.view-more"
                                                )
                                              )
                                          ),
                                          _c("i", {
                                            staticClass:
                                              "go-icon-20 go-icon-chevron-down",
                                          }),
                                        ]
                                      )
                                    : _c(
                                        "button",
                                        {
                                          staticClass: "btn go-btn-more",
                                          attrs: { type: "button" },
                                          on: {
                                            click:
                                              _vm.showLessBriefingSocialPages,
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(
                                                _vm.$t(
                                                  "briefing.my-briefing.side-bar.view-less"
                                                )
                                              )
                                          ),
                                          _c("i", {
                                            staticClass:
                                              "go-icon-20 go-icon-chevron-up",
                                          }),
                                        ]
                                      ),
                                ])
                              : _vm._e(),
                          ]),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _vm.language == "ko"
                      ? _c(
                          "div",
                          { staticClass: "go-panel companyBriefingBox" },
                          [
                            _c(
                              "a",
                              {
                                staticClass: "go-panel-header",
                                attrs: {
                                  "data-toggle": "collapse",
                                  "data-target": "#go-topic-group3",
                                  "aria-expanded": !_vm.isCompanyCollapsed,
                                },
                                on: { click: _vm.toggleCompanies },
                              },
                              [
                                _c("div", { staticClass: "go-panel-title" }, [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(_vm.$t("briefing.companyAgents")) +
                                      "\n                "
                                  ),
                                  _c("small", { staticClass: "go-count" }, [
                                    _vm._v(
                                      "(" +
                                        _vm._s(
                                          _vm.getTotalSubscribeCompany || 0
                                        ) +
                                        ")"
                                    ),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c("div", [
                                  _c("i", {
                                    staticClass:
                                      "go-icon-20 go-icon-chevron-down",
                                  }),
                                ]),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "go-panel-body collapse show p-0",
                                attrs: { id: "go-topic-group3" },
                              },
                              [
                                _c("div", { staticClass: "go-list-wrap" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "go-list-inner overflow-y-scroll customScroll csScrollPosition ps listWrapBoxMyBriefing",
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            overflow: "hidden",
                                            width: "auto",
                                            height: "auto",
                                          },
                                        },
                                        [
                                          _c(
                                            "ul",
                                            {
                                              staticClass:
                                                "go-card-sub-list go-card-topic",
                                            },
                                            [
                                              _c(
                                                "router-link",
                                                {
                                                  class: [
                                                    {
                                                      disabled:
                                                        _vm.getIsLoadingBriefingWelcome,
                                                    },
                                                  ],
                                                  attrs: {
                                                    to: "/my-briefing/company",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "li",
                                                    {
                                                      staticClass:
                                                        "go-list-item go-list-all",
                                                      on: {
                                                        click:
                                                          _vm.setSelectedAllCompanyPage,
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "a",
                                                        {
                                                          class: [
                                                            "go-card-link go-card-sub",
                                                            {
                                                              active:
                                                                this.$route
                                                                  .name ===
                                                                "CompanyBriefing-All",
                                                            },
                                                          ],
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "go-card-img",
                                                            },
                                                            [
                                                              _c("i", {
                                                                staticClass:
                                                                  "go-icon-24 go-icon-layout-grid-fill",
                                                              }),
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "go-card-body",
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "go-card-title",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "briefing.allCompanyAgents"
                                                                      )
                                                                    )
                                                                  ),
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "go-card-info",
                                                                },
                                                                [
                                                                  _c("span", {
                                                                    staticClass:
                                                                      "go-datetime",
                                                                  }),
                                                                ]
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _vm._l(
                                                _vm.companyBriefingPages,
                                                function (item, index) {
                                                  return _c(
                                                    "router-link",
                                                    {
                                                      key: item.bpId,
                                                      class: [
                                                        "go-list-item",
                                                        {
                                                          hide:
                                                            index >=
                                                              _vm.indexShowCompany &&
                                                            !_vm.isFullSocialPages,
                                                          disabled:
                                                            _vm.getIsLoadingBriefingWelcome,
                                                        },
                                                      ],
                                                      attrs: {
                                                        to:
                                                          "/my-briefing/company/" +
                                                          item.bpId,
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "li",
                                                        {
                                                          staticClass:
                                                            "go-list-item",
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.setSelectedSocialPage(
                                                                item
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "a",
                                                            {
                                                              class: [
                                                                "go-card-link go-card-sub",
                                                                {
                                                                  active:
                                                                    _vm.$route
                                                                      .params
                                                                      .bpId ==
                                                                    item.bpId,
                                                                },
                                                              ],
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "go-card-img",
                                                                },
                                                                [
                                                                  _c("img", {
                                                                    attrs: {
                                                                      src: item.imageUri,
                                                                    },
                                                                    on: {
                                                                      error:
                                                                        _vm.onImageError,
                                                                    },
                                                                  }),
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "go-card-body",
                                                                },
                                                                [
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "go-card-title",
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          item.briefingPageName
                                                                        )
                                                                      ),
                                                                    ]
                                                                  ),
                                                                  _vm._v(" "),
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "go-card-info",
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "span",
                                                                        {
                                                                          staticClass:
                                                                            "go-datetime",
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              _vm.formatDateAgo(
                                                                                _vm.moment(
                                                                                  item.modifyDate
                                                                                )
                                                                              )
                                                                            )
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  )
                                                }
                                              ),
                                            ],
                                            2
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm.getTotalSubscribeCompany > 5
                                    ? _c(
                                        "div",
                                        { staticClass: "go-panel-footer" },
                                        [
                                          !_vm.isFullCompanyAgent &&
                                          _vm.indexShowCompany <
                                            _vm.getTotalSubscribeCompany
                                            ? _c(
                                                "button",
                                                {
                                                  staticClass:
                                                    "btn go-btn-more",
                                                  attrs: {
                                                    type: "button",
                                                    disabled:
                                                      _vm.companyBriefingPages
                                                        .length <
                                                      _vm.getTotalSubscribeCompany
                                                        ? !_vm.getCheckCallApiCompanyBP
                                                        : false,
                                                  },
                                                  on: {
                                                    click:
                                                      _vm.loadMoreCompanyAgentPages,
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "briefing.my-briefing.side-bar.view-more"
                                                        )
                                                      )
                                                  ),
                                                  _c("i", {
                                                    staticClass:
                                                      "go-icon-20 go-icon-chevron-down",
                                                  }),
                                                ]
                                              )
                                            : _c(
                                                "button",
                                                {
                                                  staticClass:
                                                    "btn go-btn-more",
                                                  attrs: { type: "button" },
                                                  on: {
                                                    click:
                                                      _vm.showLessCompanyAgentPages,
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "briefing.my-briefing.side-bar.view-less"
                                                        )
                                                      )
                                                  ),
                                                  _c("i", {
                                                    staticClass:
                                                      "go-icon-20 go-icon-chevron-up",
                                                  }),
                                                ]
                                              ),
                                        ]
                                      )
                                    : _vm._e(),
                                ]),
                              ]
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]
                ),
              ]
            ),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }